<template>
  <auth-layout>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="8">
          <v-card class="elevation-12">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>POS</v-toolbar-title>
              <v-spacer />
              <v-icon>mdi-bank</v-icon>
            </v-toolbar>
            
            <v-card-text>
              <v-row class="justify-center align-center">
                <v-col cols="12" md="6">
                  Login here or create an account
                  <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                    <v-text-field
                      label="Email"
                      v-model="user.email"
                      :rules="inputRules"
                      prepend-icon="mdi-account-outline"
                      type="text"
                    />

                    <v-text-field
                      id="password"
                      label="Password"
                      name="password"
                      v-model="user.password"
                      :rules="inputRules"
                      autocomplete="on"
                      prepend-icon="mdi-lock"
                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="showPassword ? 'text' : 'password'"
                      @click:append="showPassword = !showPassword"
                    />
                  </v-form>
                  <v-row no-gutters class="mt-2">
                    <v-btn :loading="loader" color="primary" class="right" @click="login">Login</v-btn>
                    <v-spacer></v-spacer>
                    <!-- <v-btn color="accent" to="/register" text>Or Register</v-btn> -->
                  </v-row>

                  <!-- <v-row class="pt-3">
                    <v-btn color="primary" text small to="/reset/password">Forgot password? Reset</v-btn>
                  </v-row>-->
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions></v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <!-- start of snackbar -->
      <snackbar ref="snackbar"></snackbar>
      <!-- end of snackbar -->
    </v-container>
  </auth-layout>
</template>


<script>
export default {
  data: () => ({
    lazy: false,
    valid: false,
    user: {},
    loader: false,
    showPassword: false,
    inputRules: [v => !!v || "Required"],
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+\..+/.test(v) || "E-mail must be valid"
    ]
  }),
  methods: {
    setUserData(user) {
      this.$store.commit("setUser", user);
    },
    login() {
      if (this.$refs.form.validate()) {
        const url = "/login";
        const data = this.user;
        const self = this;
        self.loader = true;
        this.$store
          .dispatch("post", { url, data })
          .then(res => {
            if (res.ResultCode == 1200) {
              self.loader = false;
              localStorage.clear();
              localStorage.setItem("token", res.ResponseData.authToken);
              localStorage.setItem("userRole", res.ResponseData.role);
              localStorage.setItem("userName", res.ResponseData.name);
              localStorage.setItem("userId", res.ResponseData.user_id);
              localStorage.setItem("user_id", res.ResponseData.user_id);
              localStorage.setItem("subscriber_id", res.ResponseData.subscriber_id);
              localStorage.setItem("IsDistributor", res.ResponseData.IsDistributor);
              localStorage.setItem("canSeeStockBalance", res.ResponseData.canSeeStockBalance);
              localStorage.setItem("canBackDate", res.ResponseData.canBackDate);
              localStorage.setItem("CanEditBpTransfer", res.ResponseData.CanEditBpTransfer);
              localStorage.setItem("CanPrintTransferDelivery", res.ResponseData.CanPrintTransferDelivery);
              localStorage.setItem("HideDebtorsTotal", res.ResponseData.HideDebtorsTotal);
              localStorage.setItem("HideTotalSales", res.ResponseData.HideTotalSales);
              localStorage.setItem("ExportsVersion", res.ResponseData.ExportsVersion);

              if(res.ResponseData.IsDistributor == "Y") {
                self.$router.push("/switch-company");
              }

              if(res.ResponseData.IsDistributor == "N") {
                self.$router.push("/switch-store");
              }

            } else {
              self.loader = false;
              this.$refs.snackbar.show(res.ResultDesc, "red");
            }
          })
          .catch(err => {
            self.loader = false;
            this.$refs.snackbar.show(err, "red");
          });
      }
    },
    setUser() {
      this.user.email = "demo@gmail.com";
      this.user.password = "tech@2024#";
    }
  },
  created() {
   // this.setUser();
  }
};
</script>
